@if (content && content.paymentMethods && content.paymentMethods.length > 0) {
<p class="p2 col-13 m-r-2 no-wrap p-t-1">{{'Pay with' | translate}}</p>
<div class="flex flex-wrap">
    @for (logo of content.paymentMethods; track $index; let isLast = $last) {
    <div class="payment-method-logo m-r-2"
         [class.m-r-2]="!isLast"
         [ngClass]="'payment-method-logo--' + logo"></div>
    }
</div>
}